import { request } from "@/api/request"

const STAFF_ID = 37

export function fetchCustomerList(payload) {
  return request.post("/mgm-crm-api/customer/list", payload).then(r => r.data)
}

export function checkInCustomer(payload = {}) {
  return request.post("/mgm-crm-api/customer/check-in", payload).then(r => r.data)
}

export function cancelBooking(id) {
  return request.post(`/mgm-crm-api/customer/cancel/${id}`, {}).then(r => r.data)
}

export function payDeposit(payload) {
  return request.post("/mgm-crm-api/customer/pay-deposit", payload).then(r => r.data)
}

export function completeCustomer(payload) {
  return request.post("/mgm-crm-api/customer/complete", payload).then(r => r.data)
}

export function assignTeacher(payload) {
  return request.post("/mgm-crm-api/customer/assigned-teacher", payload).then(r => r.data)
}

/** 新增学员 */
export function createCustomerInput(payload) {
  return request
    .post("/mgm-crm-api/customer/input", { ...payload, staffId: STAFF_ID })
    .then(r => r.data)
}

/** 邀约：设置邀约时间 */
export function bookingCustomer(payload) {
  return request.post("/mgm-crm-api/customer/booking", payload).then(r => r.data)
}

/** 编辑学员 */
export function updateCustomer(payload) {
  return request.post("/mgm-crm-api/customer/update", payload).then(r => r.data)
}

/** 字典项查询，dictTypeId 如渠道字典100 */
export function fetchDictionary(dictTypeId) {
  return request.post(`/mgm-crm-api/dictionary/query/${dictTypeId}`, {}).then(r => r.data)
}

/** 员工列表：返回字段常见为 { weName, id } */
export function fetchStaffList(payload) {
  return request.post("/mgm-crm-api/staff/query", payload).then(r => r.data)
}

